export const FormPageMixin = {
  data () {
    return {
      valid: true,
      customerDataCopy: {},
    }
  },
  props: {
    customerData: {
      type: Object,
      default: () => {
      }
    },
    hasMobileOptIn: {
      type: Boolean,
      default: false
    },
    lenderName: {
      type: String,
      default: ''
    },
  },
  methods: {
    submitForm () {
      if (this.$refs.loanApplication.validate()) {
        this.$emit('submit', this.customerDataCopy)
      } else {
        this.valid = false
      }
    },
    tooltipText (field) {
      if (this.lenderName === 'fortiva' && field.fortivaDisclaimerText) {
        return field.fortivaDisclaimerText
      } else if ( this.hasPreQual && field.greenskyPreQualDisclaimerText) {
        if(field.label === 'Cell Phone Number') {
          return this.customerDataCopy.phoneNumber.length > 0 ?
             field.greenskyPreQualMobileNumberDisclaimerText :
             field.greenskyPreQualDisclaimerText
        } else {
          return field.greenskyPreQualDisclaimerText
        }
      } else if (this.lenderName === 'greensky' && field.greenskyDisclaimerText) {
        return field.greenskyDisclaimerText
      } else {
        return field.disclaimerText
      }
    }
  },
  created () {
    this.customerDataCopy = { ...this.customerData }
  }
}
